/**
 * @file 模型库结构图弹窗
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {Fragment, ReactNode, ReactElement} from 'react';
import {Modal} from 'antd';
import {
    CloseOutlined,
    ZoomInOutlined,
    ZoomOutOutlined
} from '@ant-design/icons';
import {useModelBaseStructureModalHooks} from './modelBaseStructureModalHooks';

interface IProps {
    imgSrc: string;
    children?: ReactNode;
}

const ModelStructureModal: React.FC<IProps> = props => {
    const {imgSrc} = props;

    const {
        visible,
        imgScale,
        imgSize,

        onModalHide,
        onModalShow,
        onZoomInClick,
        onZoomOutClick
    } = useModelBaseStructureModalHooks({imgSrc});


    return (
        <Fragment>
            {React.Children.map(props.children, child => {
                if (!React.isValidElement(child)) {
                    return child;
                }
                const childElement: ReactElement = child;
                return React.cloneElement(childElement, {
                    onClick: onModalShow
                });
            })}
            <Modal
                className="paddle-model-structure-modal"
                closable={false}
                visible={visible}
                footer={null}
                onOk={onModalHide}
                onCancel={onModalShow}
                maskClosable={false}
                width={''}
            >

                <div className="paddle-model-structure-modal-img-wrap">
                    <img
                        alt={imgSrc}
                        className="paddle-model-structure-modal-img"
                        style={{
                            width: imgSize.width * imgScale,
                            height: imgSize.height * imgScale
                        }}
                        src={imgSrc}
                    />
                </div>
                <div className="paddle-model-structure-modal-btn-group">
                    <div
                        className="paddle-model-structure-modal-btn paddle-model-structure-modal-btn-close"
                        onClick={onModalHide}
                    >
                        <CloseOutlined />
                    </div>
                    <div
                        className="paddle-model-structure-modal-btn"
                        onClick={onZoomInClick}
                    >
                        <ZoomInOutlined />
                    </div>
                    <div
                        className="paddle-model-structure-modal-btn"
                        onClick={onZoomOutClick}
                    >
                        <ZoomOutOutlined />
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
};

export default ModelStructureModal;
